import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'

export const GoogleMapImage = ({
  lat,
  lng,
  showMarker = true,
  defaultZoom = 17,
}: {
  lat: number
  lng: number
  showMarker?: boolean
  defaultZoom?: number
}) => {
  const position = { lat, lng }

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY as string,
    libraries: ['places', 'marker'], // 'marker' optional, depends on your usage
  })

  if (loadError) return <p>Error loading map</p>
  if (!isLoaded) return <p>Loading map...</p>

  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '100%' }}
      center={position}
      zoom={defaultZoom}
      options={{
        fullscreenControl: false,
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
      }}
    >
      {showMarker && <Marker position={position} />}
    </GoogleMap>
  )
}
